export default __webpack_public_path__ + "static/media/img-4.6e8d0ece.png";